// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Homepage from './modules/homepage/Homepage';
import SearchPage from './modules/search/Search';
import DisplayDomainData from './modules/search/DisplayDomainData';
import PublishDomain from './modules/publish/PublishDomain';
import HowItWorks from './modules/staticModule/HowItWorks';
import FAQs from './modules/staticModule/FAQs';
import Contact from './modules/staticModule/Contact';

const App: React.FC = () => {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/getDomainData/:id" element={<DisplayDomainData />} />
      <Route path="/publishDomain" element={<PublishDomain />} />
      <Route path="/howItWorks" element={<HowItWorks />} />
      <Route path="/faqs" element={<FAQs />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  </Router>
  );
};

export default App;
